/** @format */

import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { utility } from "../Shared/Utility";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class ApiServiceService {
  SERVER_URL = environment.serverUrl;
  LOGIN_URL = environment.loginUrl;
  PAYMENT_URL = environment.paymentUrl;
  suppressAlertError: boolean = false;

  constructor(private httpClient: HttpClient) {}

  public getTemaQueryComments(applicationId: string | number): Observable<any> {
    return this.get(`/assessments/tema/retrieve-query-comments/${applicationId}`);
  }

  public getBlob(actionUrl: any): Observable<Blob> {
    const url = this.SERVER_URL + actionUrl;
    return this.httpClient.get(url, { responseType: 'blob' }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  public postBlob(actionUrl: any, request: any): Observable<Blob> {
    const url = this.SERVER_URL + actionUrl;
    return this.httpClient.post(url, request, { responseType: 'blob' }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  public get(actionUrl: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + actionUrl;
    // console.log(url);
    if (options) {
      return this.httpClient.get<any>(url, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.get<any>(url).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  public get_Two_Params(actionUrl: any): Observable<any> {
    const url = this.SERVER_URL + actionUrl;
    // if (options) {
    return this.httpClient.get<any>(url).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return this.handleError(error);
      }),
    );
    // }
  }

  public get_test_Params(actionUrl: any): Observable<any> {
    const url = actionUrl;
    // if (options) {
    return this.httpClient.get<any>(url).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return this.handleError(error);
      }),
    );
    // }
  }

  validateTin(tinNumber: string, tinType: string) {
    return this.httpClient.get<any>(
      this.SERVER_URL +
        "/user-profile/validate-tin/" +
        tinNumber +
        "/" +
        tinType,
    );
  }

  public post(actionUrl: any, request: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + actionUrl;
    if (options) {
      return this.httpClient.post<any>(url, request, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.post<any>(url, request).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  public login(actionUrl: any, request: any, options?: any): Observable<any> {
    const url = this.LOGIN_URL + actionUrl;
    if (options) {
      return this.httpClient.post<any>(url, request, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.post<any>(url, request).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  public payment(actionUrl: any, request: any): Observable<any> {
    const url = this.PAYMENT_URL + actionUrl;
    return this.httpClient.post<any>(url, request).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return this.handleError(error);
      }),
    );
    // }
  }

  public PaymentGet(actionUrl: any): Observable<any> {
    const url = this.PAYMENT_URL + actionUrl;
    return this.httpClient.get<any>(url).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return this.handleError(error);
      }),
    );
  }

  public logout(actionUrl: any, request?: any, options?: any): Observable<any> {
    const url = this.LOGIN_URL + actionUrl;
    if (options) {
      return this.httpClient.post<any>(url, request, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.post<any>(url, request).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  public LoginGet(actionUrl: any, options?: any): Observable<any> {
    const url = this.LOGIN_URL + String(actionUrl);
    if (options) {
      return this.httpClient.get<any>(url, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.get<any>(url).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  public put(actionUrl: any, request: any, options?: any): Observable<any> {
    const url = this.SERVER_URL + actionUrl;
    if (options) {
      return this.httpClient.put<any>(url, request, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.put<any>(url, request).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  public get_(actionUrl: any): Observable<any> {
    return this.get(actionUrl, { headers: utility.allHeader });
  }

  public post_(actionUrl: any, request: any): Observable<any> {
    return this.post(actionUrl, request, { headers: utility.allHeader });
  }

  public loginPost_(actionUrl: any, request: any): Observable<any> {
    return this.login(actionUrl, request, { headers: utility.allHeader });
  }
  public loginPost2_(actionUrl: any, request: any): Observable<any> {
    return this.login(actionUrl, request, {
      headers: utility.multipartHeader,
    });
  }

  public paymentPost_(actionUrl: any, request: any): Observable<any> {
    return this.payment(actionUrl, request);
  }

  public loginGet_(actionUrl: any, request: any): Observable<any> {
    return this.login(actionUrl, request, { headers: utility.allHeader });
  }

  public post_g(actionUrl: any): Observable<any> {
    return this.post(actionUrl, { headers: utility.allHeader });
  }

  public put_(actionUrl: any, request: any): Observable<any> {
    return this.put(actionUrl, request, { headers: utility.allHeader });
  }

  public postUser(
    actionUrl: any,
    request: any,
    options?: any,
  ): Observable<any> {
    const url = this.LOGIN_URL + actionUrl;
    if (options) {
      return this.httpClient.post<any>(url, request, options).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    } else {
      return this.httpClient.post<any>(url, request).pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return this.handleError(error);
        }),
      );
    }
  }

  handleError(error: HttpErrorResponse) {
    if (this.suppressAlertError) {
      return throwError(error);
    } else {
      let errorMessage = "Unknown error!";
      if (error.error instanceof ErrorEvent) {
        errorMessage = `Error: ${error.error.message}`;
      } else {
        errorMessage = `${error.message}`;
      }
      return throwError(errorMessage);
    }
  }

  getItems(page: number, size: number): Observable<any[]> {
    const url =
      this.PAYMENT_URL +
      "/api/payment/split-account/unconfigure/revenues/split";
    const params = new HttpParams()
      .set("page", page.toString())
      .set("size", size.toString());

    return this.httpClient.get<any[]>(url, { params });
  }

  searchItems(search: string, page: number, size: number): Observable<any[]> {
    const url =
      this.PAYMENT_URL +
      "/api/payment/split-account/unconfigure/revenues/split";
    const params = new HttpParams()
      .set("page", page.toString())
      .set("size", size.toString())
      .set("search", search);

    return this.httpClient.get<any[]>(url, { params });
  }
  encriptData(payload: any) {
    const key = CryptoJS.enc.Utf8.parse("1234567890123456");
    const iv = CryptoJS.enc.Utf8.parse("1234567890123456");
    return CryptoJS.AES.encrypt(payload, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
  }

  decrypt(response: any) {
    const KEY = CryptoJS.enc.Utf8.parse("1234567890123456");
    const IV = CryptoJS.enc.Utf8.parse("1234567890123456");

    const bytes = CryptoJS.AES.decrypt(response, KEY, {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
}
